export const useNewWindowNavigate = () => {
  const openNewWindow = (path: string = '') => {
    window.open(`${window.location.origin}/${path}`, '_blank');
  };
console.log(window.location);
  return openNewWindow
};
